/* h5登录后防沉迷弹窗, 支付前防沉迷确认窗口 */

<template>
  <div :class="$style.antiIndulged">
    <AntiInduled
      :branch="branch"
      :type="antiInduledType"
      :customer="antiInduled_customer"
      title="防沉迷提示"
      @submit="submit"
      @changeData="changeData"
      @confirm="confirm"
      @quitGame="quitGame"
      @cancel="cancel"
      @rebind="rebind"
      @backLogin="backLogin"
      ref="antiInduled"
      v-if="antiInduledType || antiInduledType === 0"
    ></AntiInduled>
  </div>
</template>

<script>
import AntiInduled from '@/components/antiIndulged/index.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import { idBind } from '@/api/user';

export default {
  name: '',
  data() {
    return {
      antiInduledType: null,
      msg: ''
    };
  },
  components: {
    AntiInduled
  },
  computed: {
    ...mapState({
      userState: state => state.user,
      branch: state => state.user.h5_branch,
      quit_type: state => state.user.quit_type,
      antiInduled_customer: state => state.user.antiInduled_customer,
      antiIndulgedInfo: state => state.user.antiIndulgedInfo,
      antiIndulgedPayInfo: state => state.user.antiIndulgedPayInfo
    })
  },
  mounted() {
    this.initState();
  },
  methods: {
    ...mapActions({
      realNameVerify: 'user/realNameVerify'
    }),
    ...mapMutations({
      changeGlobalState: 'global/CHANGE_STATE',
      changeUserState: 'user/CHANGE_STATE',
      notifyCpBindIdCard: 'user/notifyCpBindIdCard'
    }),
    initState() {
      if (this.branch === 'payment') {
        this.antiInduledType = this.antiIndulgedPayInfo.code;
      } else {
        const { antiIndulgedInfo, quit_type, idBindCheckState } = this.$store.state.user;
        if (!quit_type && antiIndulgedInfo) {
          /**
           * 非客户端打开，并且vuex中存存在防沉迷数据情况
           * fatigue_state  0 防沉迷开关关闭 1 防沉迷开关打开
           * code 相关提示窗口code，根据产品蓝湖中的设计稿判断，防沉迷打开关闭以fatigue_state判断
           */
          const { fatigue_state, user_info } = antiIndulgedInfo;
          if (!idBindCheckState) {
            // 非验证真实实名认证需要重新实名认证的情况, 此时是因为防沉迷走到这里，一定存在user_info
            this.antiInduledType = [fatigue_state === 0 ? 1 : 0, Number(user_info.code)];
          } else {
            this.antiInduledType = [fatigue_state === 0 ? 1 : 0, 1];
          }
        } else if (quit_type) {
          /**
           * 在游客模式或未成年到达游戏时长限制后客户端打开改窗口
           * quit_type 1.游客模式到达1小时 2.未成年到达1.5小时 3.节假日3小时 4.未成年22：00~8:00
           */
          this.antiInduledType = [0, 5];
        }
      }
    },
    quitGame() {
      location.reload();
    },
    backLogin() {
      location.reload();
    },
    /**
     * 提交实名认证
     * @param {Object} form 身份证信息表单
     * @param {number} flag 未成年用户提交认证标识，认证成功后跳转未成年用户认证成功确认界面 详见产品文档
     */
    async submit(form, flag) {
      form = {
        ...form,
        uid: this.userState.user_id,
        jh_app_id: this.userState.appkey,
        access_token: this.userState.access_token
      };
      const { id_card_name, id_card_num } = form;
      const verifyResult = await this.realNameVerify({ id_card_name, id_card_num });
      if (verifyResult) {
        this.$toast(verifyResult);
        if (flag) this.$refs.antiInduled.rebind();
        return;
      }
      // 实名认证
      try {
        const r = await idBind(form);
        this.$toast('认证成功');
        this.changeUserState({ id_card_status: true });
        // 在支付页面认证成功，关闭防重复点击标识
        this.changeGlobalState({ preventBrush: false });
        setTimeout(() => {
          if (r.content.id_status == 2) {
            // 2. 未成年用户
            this.changeUserState({
              h5AntiIndulgedResult: {
                is_bind_ID_card: 1,
                is_adult: 0
              }
            });
            this.notifyCpBindIdCard(r.content.id_status); // 游戏过程中弹窗的情况下，绑定了未成年用户 通知游戏
            if (this.branch === 'login') {
              this.antiInduledType = [0, 4];
              this.remainTime = '';
            } else {
              this.antiInduledType = 1;
            }
          } else {
            // 3.已成年用户
            this.changeUserState({
              h5AntiIndulgedResult: {
                is_bind_ID_card: 1,
                is_adult: 1
              }
            });
            if (this.quit_type) {
              // 游客模式用尽弹窗后实名认证完
              this.notifyCpBindIdCard(r.content.id_status);
              this.close();
            } else {
              if (this.branch === 'login') {
                this.$emit('notifyLogin');
              } else {
                this.notifyCpBindIdCard(r.content.id_status);
                this.close();
              }
            }
          }
        }, 1500);
      } catch (error) {
        if (flag) this.$refs.antiInduled.rebind();
      }
    },
    close() {
      this.$toast('认证成功');
      setTimeout(() => {
        this.changeUserState({ antiIndulgedVisible: false });
      }, 1500);
    },
    changeData(key, value) {
      this[key] = value;
    },
    /**
     * @param { string } type 当前防沉迷窗口类型
     * 针对不同情况的处理：
     * 1,2 开启实名认证未开防沉迷;用户可正常进入游戏，但会弹窗
     * 0,4 开启实名认证开启防沉迷，未成年实名认证后弹窗
     */
    confirm() {
      if (this.branch === 'payment' || this.quit_type) {
        this.changeUserState({ antiIndulgedVisible: false });
      } else {
        // 登录后直接提示未成年确认框，而非绑定后提示，需要改变下防沉迷状态通知研发
        this.changeUserState({
          h5AntiIndulgedResult: {
            is_bind_ID_card: 1,
            is_adult: 0
          }
        });
        // 登录是未成年用户绑定，通知客户端登录
        this.$emit('notifyLogin');
      }
    },
    cancel() {
      this.changeUserState({ antiIndulgedVisible: false });
      // 在支付页面认证成功，关闭防重复点击标识
      this.changeGlobalState({ preventBrush: false });
    },
    // 游客模式登录
    // visitorModeLogin() {
    //   const { fatigue_state, open } = this.antiIndulgedInfo;
    //   // 通知游客模式登录
    //   this.changeUserState({
    //     h5AntiIndulgedResult: {
    //       is_bind_ID_card: 0,
    //       is_adult: 0
    //     }
    //   });
    //   this.$emit('notifyLogin');
    // },
    rebind() {
      location.reload();
    }
  }
};
</script>

<style lang="scss" module>
.antiIndulged {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  /* background: rgba(0, 0, 0, 0.4); */
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(0, 0, 0, 0.5); */
    z-index: 1;
  }
}
</style>